import { FeedRoom } from "../../../../../models"

export const UPPEND_DATA_RESULT = 'UPPEND_DATA_RESULT'
export const UPDATE_DATA_RESULT = 'UPDATE_DATA_RESULT'
export const UPDATE_NEW_COMMENTS_CHAT = 'UPDATE_NEW_COMMENTS_CHAT'

export interface UppendDataResultAction {
    type: string
    result: FeedRoom
}
export interface UpdateNewCommentsAction {
    type: string
    chatId: string
    commentsCount: number
    newComments: number
}
export interface UpdateDataResultAction {
    type: string
    chatId: string
    result: FeedRoom
}

export const uppendDataResult = (result: FeedRoom): UppendDataResultAction => ({
    type: UPPEND_DATA_RESULT,
    result
})

export const updateNewCommentsChat = (chatId: string, newComments: number, commentsCount: number): UpdateNewCommentsAction => ({
    type: UPDATE_NEW_COMMENTS_CHAT,
    chatId,
    commentsCount,
    newComments
})
export const updateDataResult = (chatId: string, result: FeedRoom): UpdateDataResultAction => ({
    type: UPDATE_DATA_RESULT,
    chatId,
    result
})
